<template>
  <div class="countdown-container">
    <slot>
      <h3 class="countdown-title">— 距离活动结束还有 —</h3>
    </slot>
    <div class="countdown-box" v-if="!timeLeft">倒计时计算中...</div>
    <div class="countdown-box" v-if="timeLeft">
      <div class="item">
        <strong class="value">{{ result.days }}</strong>
        <span class="unit">天</span>
      </div>
      <div class="item">
        <strong class="value">{{ result.hours }}</strong>
        <span class="unit">时</span>
      </div>
      <div class="item">
        <strong class="value">{{ result.minutes }}</strong>
        <span class="unit">分</span>
      </div>
      <div class="item">
        <strong class="value">{{ result.seconds }}</strong>
        <span class="unit">秒</span>
      </div>
    </div>
  </div>
</template>



<script>
export default {
  name: "CountDown",
  props: {
    etime: {
      type: String,
      default: "",
    },
    actionText: {
      type: String,
      default: "剩余",
    },
  },
  data() {
    return {
      deadline: "",
      timeLeft: "",
      statusText: "",
      result: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
    };
  },
  components: {},
  computed: {},
  methods: {
    changeTime(timeStr) {
      this.deadline = new Date(timeStr.replace(/-/g, "/")).getTime();
      this.countDown(this.deadline);
    },
    formatDuring(mss) {
      var mss = this.deadline - new Date().getTime();
      // console.log("结束日期", this.deadline);
      // console.log((new Date()).getTime())
      // console.log('倒计时mss',mss)
      if (mss > 0) {
        let days = parseInt(mss / (1000 * 60 * 60 * 24));
        let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = parseInt((mss % (1000 * 60)) / 1000);
        this.timeLeft = `${days}天${hours < 10 ? "0" + hours : hours}时${minutes < 10 ? "0" + minutes : minutes
          }分${seconds < 10 ? "0" + seconds : seconds}秒`;
        this.result.days = days;
        this.result.hours = hours;
        this.result.minutes = minutes;
        this.result.seconds = seconds;
      } else {
        this.timeLeft = `投票已结束`;
        this.statusText = "";
      }
    },

    countDown() {
      window.setInterval(() => {
        this.formatDuring();
      }, 1000);
    },
  },
  created() {
    this.changeTime(this.etime);
    this.statusText = this.actionText;
  },
  watch: {},
};
</script>

<style scoped lang="less">
.countdown-container {
  width: 100%;
  padding: 0.4rem 0;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .countdown-title {
    color: var(--themeColor);
    text-align: center;
    font-size: 0.36rem;
    margin-bottom: 0.3rem;
  }

  .countdown-box {
    margin: .2rem auto 0;
    color: var(--themeColor);
    font-size: 0;
    border-radius: 0.2rem;
    text-align: center;

    .item {
      display: inline-block;
      vertical-align: middle;
      font-size: 0;

      .value,
      .unit {
        display: inline-block;
        vertical-align: baseline;
        line-height: initial;
        margin: 0 2px;
      }

      .value {
        font-size: 0.72rem;
        color: var(--themeColor);
      }

      .unit {
        font-size: 0.32rem;
        color: #999;
      }
    }
  }
}
</style>